<template>
    <div class="message-container d-flex justify-content-center mb-2 incoming call outbound">
        <div class="message">
            <div class="content d-flex align-items-center" :style="styles">
                <div class="call__info">
                    <div class="call__type d-block  mb-1">
                        {{ typeText }}
                    </div>
                    <div class="call__duration d-block">
                        <i class="fas fa-arrow-up"></i> {{ duration }}
                    </div>
                </div>
                <div class="call-button">
                    <i class="fas fa-phone-alt"></i>
                </div>
            </div>
            <div class="footer text-black-50">{{ beginAtFormatted }}</div>
        </div>
    </div>
</template>

<script>
  import ChatCallMessage from './chat-call-message';

  export default {
    extends: ChatCallMessage,

    computed: {
      /**
       * @return {String}
       */
      typeText() {
        return 'Outgoing call';
      },

      /**
       * @return {Object}
       */
      styles() {
        const {
          'brand.item.text.color': color,
          'brand.item.background.color': backgroundColor
        } = _.get(this.brand, 'styles') || {};

        // remove empty values
        return _.pickBy({color, backgroundColor}, _.identity);
      },
    },
  }
</script>
